<template>
    <div class="l-ss-c-search-results">
        <div
            v-if="isLoading && false"
            class="l-ss-c-results-loader">
            <pulse-dots/>
        </div>
        <div
            v-else
            :class="{ 'l-ss-c-filters-left': filterPositionLeft, [`l-ss-c-search-popup-is-masked`]: isMaskVisible }"
            :style="!$configuration.showInput ? 'padding-top: 0' : ''">
            <div
                v-if="isResultsVisible"
                class="l-ss-c-popup-slot-top">
                <autocomplete
                    :is-loading="isLoading"
                    :search="search"
                    class="l-ss-c-popup-slot-top-column l-ss-c-popup-slot-top-column-is-left"
                    @autocomplete-search="val => $emit('autocomplete-search', val)"
                    @params-search="params => $emit('params-search', params)"/>
            </div>
            <div
                v-show="isMaskVisible"
                class="l-ss-c-search-popup-mask"
                @click="onPopupMaskClick"></div>
            <popup
                :opened="store.state.ui.isFiltersOpened"
                :title="$t('filters.titleAll')"
                class="l-ss-c-search-popup-filters-popup"
                @close="() => toggleFilters(false)">
                <section-full-filters
                    :filters="filterItems"
                    :has-results="hasResults"
                    :has-selected="hasFilters"
                    :total-items-count="totalItemsCount"
                    :values="filterValues"
                    @change="filters => $emit('filters-change', filters)"
                    @close="() => toggleFilters(false)"
                    @reset="() => $emit('reset-filters')"/>
            </popup>
            <section-image
                v-show="(store.state.ui.isImageContours || base64Image) && image"
                :image="store.state.ui.isImageContours || { contours: [], src: '' }"
                :key="sectionImageKey"
                @search="onImageSearch"
                @crop-change="onCropChange"
                @contour-click="$contour => $emit('contour-click', $contour)"/>
            <div :class="{ 'l-ss-c-filters-left-container': filterPositionLeft }">
                <section-filters
                    v-show="isFiltersBlockVisible && isResultsVisible"
                    :currency="currencyInOffers"
                    :filter-position-left="filterPositionLeft"
                    :filters="filterItems"
                    :has-results="hasResults"
                    :has-selected="hasFilters"
                    :show-sorting="showSorting"
                    :sort-by="sortBy"
                    :sort-dest="sortDest"
                    :total-items-count="totalItemsCount"
                    :values="filterValues"
                    search-type="search-results"
                    class="l-ss-c-search-popup-content-wrapper-child"
                    @change="filters => $emit('filters-change', filters)"
                    @filter-click="params => $emit('filter-click', params)"
                    @sort-change="params => $emit('sort-change', params)"
                    @result-sort-click="params => $emit('result-sort-click', params)"
                    @reset-filters="() => $emit('reset-filters')"
                    @close-filters="() => toggleFilters(false)"
                    @open-filters="() => toggleFilters(true)"
                    @toggle-image-picker="event => toggleImagePicker(event)"/>
                <section-results
                    v-if="isResultsVisible"
                    ref="search-results"
                    :categories="allCategoriesList"
                    :category-id="resultsCategoryId"
                    :error-text="requestErrorText"
                    :filter-position-left="filterPositionLeft"
                    :group-categories="$configuration.features.shouldGroupCategories"
                    :has-filters="hasFilters"
                    :has-loaded-once="hasLoadedOnce"
                    :has-query="hasQuery"
                    :has-results="hasResults"
                    :is-loading="isLoading"
                    :limit="limit"
                    :search="searchResponse"
                    :search-request-id="searchRequestId"
                    :skip="skip"
                    :templates="offerTemplates"
                    :total-items-count="totalItemsCount"
                    :query="query"
                    class="l-ss-c-search-popup-content-wrapper-child"
                    @navigate-category="params => $emit('navigate-category', params)"
                    @navigate-page-next="() => $emit('navigate-page-next')"
                    @navigate-page-prev="() => $emit('navigate-page-prev')"
                    @reset-category="onResetCategory"
                    @offer-click="params => $emit('offer-click', params)"
                    @add-to-cart-click="params => $emit('add-to-cart-click', params)"
                    @add-to-cart="args => $emit('add-to-cart', args)"
                    @reset-filters="() => $emit('reset-filters')"
                    @reset-query="() => $emit('reset-query')"
                    @handle-tags-click="(value) => onTapAction(value)"
                    @result-tab-click="(value) => $emit('result-tab-click', value)"
                    @result-category-click="(value) => $emit('result-category-click', value)"
                    @view-in-category-click="(value) => $emit('view-in-category-click', value)"
                    @page-reload="params => $emit('page-reload', params)"
                    @scroll-to-top="handleScrollToTop">
                    <template #filtersSort>
                        <section-filters-sort
                            v-if="isFiltersBlockVisible && isResultsVisible && filterPositionLeft"
                            :filter-position-left="filterPositionLeft"
                            :filters="filterItems"
                            :show-sorting="showSorting"
                            :sort-by="sortBy"
                            :sort-dest="sortDest"
                            class="l-ss-c-search-popup-content-wrapper-child"
                            @sort-change="params => $emit('sort-change', params)"
                            @result-sort-click="params => $emit('result-sort-click', params)"/>
                    </template>
                    <template #top>
                        <custom-block
                            v-if="$configuration.searchResult.topBlock"
                            :custom-template="$configuration.searchResult.topBlock"/>
                        <info-banner v-if="from_completions">
                            <span>{{ $t('selectedFiltersText') }}: {{ from_completions }}</span>
                            <button
                                class="l-ss-c-button l-ss-c-filters-full-action l-ss-c-button-secondary"
                                @click="() => $emit('reset-filters')">
                                {{ $t('filters.resetAllText') }}
                            </button>
                        </info-banner>
                        <info-banner v-show="search && search.hits > $configuration.limitForQueryRefine">
                            <span>{{ $t('results.overLimitResults') }}</span>
                        </info-banner>
                    </template>
                </section-results>
            </div>
        </div>
    </div>
</template>

<script>
    import SectionResults from '@/core/components/section-results';
    import SectionFilters from '@/core/components/filters/section-filters';
    import SectionFiltersSort from '@/core/components/filters/section-filters-sort';
    import SectionImage from '@/core/components/section-image';
    import InfoBanner from '@/core/components/info-banner';
    import Popup from '@/core/components/popup';
    import SectionFullFilters from '@/core/components/filters/section-full-filters';
    import CustomBlock from '@/core/components/custom-block';
    import ClickOutside from '@/core/directives/clickOutside.js';
    import store from '@/core/store';
    import Autocomplete from '@/core/components/autocomplete';
    
    export default {
        components: {
            SectionFilters,
            SectionFiltersSort,
            SectionResults,
            SectionImage,
            InfoBanner,
            CustomBlock,
            Popup,
            SectionFullFilters,
            Autocomplete,
        },
        directives: {
            'click-outside': ClickOutside,
        },
        props: {
            search: {
                type: Object,
                required: false,
                default: () => null,
            },
            from_completions: {
                type: String,
                default: '',
            },
            filterValues: {
                type: Array,
            },
            currencyInOffers: {
                type: String,
                default: '',
            },
            sortDest: {
                type: String,
                default: '',
            },
            sortBy: {
                type: String,
                default: '',
            },
            filterItems: {
                type: Array,
            },
            offerTemplates: {
                type: Object,
                required: false,
            },
            skip: {
                type: [String, Number],
                default: '',
            },
            searchRequestId: {
                type: String,
                default: '',
            },
            searchResponse: {
                type: Object,
                required: false,
                default: () => null,
            },
            limit: {
                type: Number,
                default: 0,
            },
            isSearchLoading: {
                type: Boolean,
                default: false,
            },
            isCompletionsLoading: {
                type: Boolean,
                default: false,
            },
            hasResults: {
                type: Boolean,
                default: false,
            },
            hasQuery: {
                type: Boolean,
                default: false,
            },
            hasLoadedOnce: {
                type: Boolean,
                default: false,
            },
            hasFilters: {
                type: Boolean,
                default: false,
            },
            errorTextCompletions: {
                type: String,
                default: '',
            },
            errorTextSearch: {
                type: String,
                default: '',
            },
            resultsCategoryId: {
                type: [String, Number, Array],
            },
            requestCategories: {
                type: Object,
                required: false,
                default: () => null,
            },
            isFiltersBlockVisible: {
                type: Boolean,
                default: false,
            },
            isResultsVisible: {
                type: Boolean,
                default: false,
            },
            totalItemsCount: {
                type: Number,
                default: 0,
            },
            query: {
                type: String,
                default: '',
            },
            searchState: {
                type: Object,
                default: () => ({
                    public: {},
                    private: {},
                }),
            },
            store: {
                required: true,
                type: Object,
                default: () => store,
            },
        },
        data() {
            return {
                base64Image: null,
                base64ImageResult: null,
                sectionImageKey: '',
            };
        },
        computed: {
            filterPositionLeft() {
                return this.$configuration.layout.filterPosition === 'left' && !this.$screen.isMobile && this.totalItemsCount >
                    0;
            },
            requestErrorText() {
                return this.errorTextCompletions || this.errorTextSearch || '';
            },
            isCategoriesLoading() {
                return this.requestCategories ? this.requestCategories.isLoading : false;
            },
            isLoading() {
                return this.isCompletionsLoading || this.isSearchLoading || this.isCategoriesLoading;
            },
            categoriesResponse() {
                return this.requestCategories ? this.requestCategories.response : null;
            },
            allCategoriesList() {
                return this.categoriesResponse || [];
            },
            showSorting() {
                return (Boolean(this.hasResults));
            },
            hasImageSearchResults() {
                return Boolean(this.searchState.private && this.searchState.private.image);
            },
            image() {
                return this.hasImageSearchResults ? this.searchState.private.image : '';
            },
            isMaskVisible() {
                return this.store.state.ui.isImageSearchVisible ||
                    this.store.state.ui.isCategoriesListVisible ||
                    this.store.state.ui.isFiltersOpened ||
                    this.showCompletions;
            },
        },
        watch: {
            'searchState.public': function (state) {
                if (this.localQueryParams && this.localQueryParams.query !== state.query) {
                    this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                    this.base64ImageResult = null;
                }
                this.localQueryParams = state ? { ...state } : {};
            },
            'store.state.base64ImageResult': {
                handler(value) {
                    if (this.store.state.base64ImageResult) {
                        this.isBase64ImageChanged = true;
                        this.onImageSearch(this.store.state.base64ImageResult);
                    }
                },
            },
            'store.state.base64Image': {
                handler(value) {
                    this.base64Image = this.store.state.base64Image;
                },
            },
            base64Image() {
                this.isBase64ImageChanged = true;
            },
        },
        methods: {
            onPopupMaskClick() {
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.base64Image = null;
                this.base64ImageResult = null;
            },
            onTapAction(value) {
                this.$emit('search-input-change', { query: value, focus: false });
                this.$emit('handle-search');
            },
            handleScrollToTop() {
                this.$refs['search-results'].$el.scrollIntoView({
                    block: 'start',
                    behavior: 'smooth',
                });
            },
            toggleFilters(value) {
                const resultValue = value === undefined ? !this.store.state.ui.isFiltersOpened : !!value;
                if (resultValue) {
                    this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                    this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                }
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: resultValue });
            },
            toggleImageSearch(value) {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isImageSearchVisible',
                    value: value === undefined ? !this.store.state.ui.isImageSearchVisible : !!value,
                });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
                this.base64Image = null;
                this.base64ImageResult = null;
            },
            onFileBase64Change(base64Image) {
                this.base64Image = base64Image;
            },
            onCropChange(event) {
                this.base64ImageResult = event.canvas.toDataURL('image/jpeg');
            },
            onImageSearch(base64ImageResult) {
                if (base64ImageResult) {
                    this.base64ImageResult = base64ImageResult;
                }

                if (this.isBase64ImageChanged) {
                    this.isBase64ImageChanged = false;
                    this.sectionImageKey = this.base64Image;
                }

                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.$emit('search-image', { base64: this.base64ImageResult });
            },
            toggleImagePicker(event) {
                this.toggleImageSearch(true);
                this.$emit('button-image-click', { type: 'buttonImageClick', event });
            },
            onResetCategory() {
                this.resetSelectedCategoryId();
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategorySearch', value: false });
                this.emitNavigateCategory({ skip: 0, categoryId: '' });
            },
        },
    };
</script>